import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
const CART_URL = 'https://www.conesenciavital.com/cart/48189528899823:1';
export function CTAButton({
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href={CART_URL} target="_blank" rel="noopener noreferrer" onClick={onClick} className={`
        inline-block
        bg-amber text-navy-darkest font-bold uppercase tracking-wider
        px-8 py-4 rounded-lg text-sm md:text-base
        animate-pulse-glow
        transition-all duration-300
        hover:bg-amber-light hover:scale-105
        focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2 focus:ring-offset-navy-darkest
        text-center no-underline
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-19">
      {children}
    </motion.a>;
}